import { FC, useMemo } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import _ from 'lodash';
import { TextInput } from '@ts/storybook';
import ItemTypeTab from '../ItemTypes/ItemTypeGeneralTab';
import { CElementType, IForm } from '@ts/ui-models';
import { TMode } from '@ts/ui-models';

interface LivestockFormProps extends WithTranslation, IForm {
  values: CElementType;
}

const LivestockForm: FC<LivestockFormProps> = ({ t, values, onCallbackChange, ...restProps }) => {
  const rows = useMemo(
    () => [
      {
        id: 'name',
        name: t('Name'),
        value: (disabled = false) => (
          <TextInput
            disabled={disabled}
            label="Name"
            value={values.name}
            onChange={onCallbackChange('name')}
            infoText="Blank spaces at the beginning and the end will be trimmed on save"
          />
        ),
      },
      {
        id: 'notes',
        name: t('Notes'),
        value: (disabled = false) => (
          <TextInput multiline disabled={disabled} label="Notes" value={values.notes} onChange={onCallbackChange('notes')} />
        ),
      },
    ],
    [t, values, onCallbackChange]
  );

  return <ItemTypeTab {...restProps} values={values} onCallbackChange={onCallbackChange} rows={rows} />;
};

export default withTranslation()(LivestockForm);
